import { motion } from 'framer-motion';

// Duplicates the item list 3x and animates a continuous horizontal loop -
// translating exactly -50%/50% of the doubled-then-tripled track keeps the
// seam invisible regardless of viewport width.
const MarqueeRow = ({ items, renderItem, direction = 'left', speed = 40, gap = 24 }) => {
  const repeated = [...items, ...items, ...items];
  const animate = direction === 'left' ? { x: ['0%', '-33.333%'] } : { x: ['-33.333%', '0%'] };

  return (
    <div className="relative overflow-hidden w-full">
      <motion.div
        className="flex w-max"
        style={{ gap }}
        animate={animate}
        transition={{ duration: speed, ease: 'linear', repeat: Infinity }}
      >
        {repeated.map((item, i) => (
          <div key={i} className="shrink-0">
            {renderItem(item)}
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default MarqueeRow;
